




























































































































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import { CampaignTypes } from '@/modules/base-campaign/models/base-campaign-resource.model'
import AdminUserSearch from '@/modules/user/components/admin/AdminUserSearch.vue'
import TesDatePicker from '@/modules/shared/components/shared/kit/TesDatePicker.vue'
import { CouponRequestModel } from '@/modules/coupon/models/coupon-request.model'
import { CouponDiscountUnit, CouponStatus } from '@/modules/coupon/models/coupon-resource.model'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import collect from 'collect.js'
import Radio from '@/modules/shared/components/shared/kit/Radio.vue'

@Component({
  components: {
    Radio,
    Toggle,
    BaseCard,
    TesDatePicker,
    AdminUserSearch,
    BaseSelect,
    CurrencyInput,
    BaseInput,
    BaseButton
  }
})
export default class AdminCouponBaseForm extends Vue {
  @Prop({ required: true }) campaignTypesInPersian: { [key in CampaignTypes]: string }
  @Prop({ required: true }) couponStatuses: { [key in CouponStatus]: string }
  @Prop({ required: true }) couponDiscountUnits: { [key in CouponDiscountUnit]: string }
  @Prop({ default: false }) loading: boolean

  protected __codeInputDisability: boolean = false

  protected __typeInputDisability: boolean = false

  protected __amountInputDisability: boolean = false

  protected __loadingState: boolean = false

  protected prohibitedServiceSearchDefault: number[] = []

  protected requiredServiceSearchDefault: number[] = []

  protected userSearchDefault: number[] = []

  discountUnit = CouponDiscountUnit

  protected requestData: CouponRequestModel = {
    amount: null,
    code: null,
    expired_at: null,
    item_quantity_limit: null,
    prohibited_services: [],
    required_services: [],
    status: CouponStatus.ACTIVE,
    title: null,
    type: CampaignTypes.CONTENT,
    usage_count_limit: null,
    user_usage_limit: null,
    users: [],
    special_offer: false,
    instructions: '',
    discount_unit: CouponDiscountUnit.FIXED,
    maximum_discount: null,
    minimum_number_purchase: null
  }

  protected get loadingState() {
    return this.loading || this.__loadingState
  }

  protected get campaignTypeOptions() {
    return collect(this.campaignTypesInPersian).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  protected get couponStatusOptions() {
    return collect(this.couponStatuses).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  protected setValue(key, value) {
    this.$set(this.requestData, key, value)
  }

  protected setValueAsNumber(key, value) {
    const parsedValue = parseInt(value, 10)
    this.setValue(key, (parsedValue >= 0) ? parsedValue : null)
  }

  protected onSubmit() {
  }
}
